export class Locale {

	constructor(messages: Object) {
		this.messages = messages;
	}

	get(key: string): string {
		return this.messages[key] || key;
	}

}
